import Tooltip from '@tencent/dui/lib/components/Tooltip';
import React from 'react';
import { evaluate } from '../../controllers/base/evaluate.js';
import { PositionedTooltip } from './auto-positioned-tooltip.js';
import { getDUIPlacement, getDUIAlignment, isTooltipConfig } from './tooltip-config.js';

/**
 * 自定义tooltip组件，包含不超出可视范围的功能
 * @internal
 * @param wrappedComponent - 被tooltip包裹的组件
 * @param tooltipConfig - tooltip用户配置项
 * @param tooltipProps - 非用户配置
 */
function withAutoPositionedTooltip(wrappedComponent, tooltipConfig, tooltipProps) {
    const tooltipContent = evaluate(tooltipConfig, undefined);
    // tooltip不存在直接不展示
    if (!tooltipContent) {
        return React.createElement(Tooltip, Object.assign({ overlayHoverable: false }, tooltipProps, { placement: getDUIPlacement(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.placement), alignment: getDUIAlignment(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.alignment), title: tooltipContent, disabled: true }), wrappedComponent);
    }
    if (!isTooltipConfig(tooltipContent)) {
        return React.createElement(Tooltip, Object.assign({ overlayHoverable: false }, tooltipProps, { placement: getDUIPlacement(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.placement), alignment: getDUIAlignment(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.alignment), title: tooltipContent }), wrappedComponent);
    }
    const config = tooltipContent;
    return React.createElement(PositionedTooltip, Object.assign({ placement: "left", safeWidth: 200, hoverDelay: 400, overlayHoverable: false }, config, tooltipProps, { title: config.content }), wrappedComponent);
}

export { withAutoPositionedTooltip };
//# sourceMappingURL=with-auto-positioned-tooltip.js.map
